import * as icons from '@workspace/assets/icons';

export const IconMap = {
  ...icons,
  // Social media platform mapping
  facebook: icons.Facebook,
  instagram: icons.Instagram,
  linkedin: icons.LinkedIn,
  tiktok: icons.TikTok,
  youtube: icons.Youtube,
  pinterest: icons.Pinterest,
  linked: icons.Linked,
};
